import { gql } from '@apollo/client'

const quoteStatusQuery = gql`
    query quoteStatus($id: UUID!) {
        quote(id: $id) {
            id
            status
            isLocked
        }
    }
`

export default quoteStatusQuery
